import AccountUserEdit from './components/AccountUserEdit';
import withRouter from 'react-router-dom/withRouter';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import has from 'lodash/has';
import get from 'lodash/get';

import {
  updateUser,
  loadUser,
  createUser,
  loadLinkInfoForUser
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  return {
    isPending:false,
    needsLoading:!has(state,['entities','users',props.userId]),
    accountId:props.accountId,
    userId:props.userId,
    existingUser:get(state,['entities','users',props.userId]),
    existingAccount:get(state,['entities','agencies',props.accountId])
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ 
    loadUser,
    updateUser,
    createUser,
    loadLinkInfoForUser 
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AccountUserEdit));



// WEBPACK FOOTER //
// ./src/routes/AccountUserEdit/index.js